const REQUIRED_ADDRESS_FIELDS = ['address1', 'city', 'postalCode'];

const isBlank = value => value === null || value === undefined || String(value).trim() === '';

// Allstar used to collect the address and tax number of UK orgs, so an org that never finished its
// Allstar set-up may have neither on its billing information.
export const isCompanyDetailsMissing = billingInformation =>
  !!billingInformation &&
  (isBlank(billingInformation.taxNumber) ||
    REQUIRED_ADDRESS_FIELDS.some(field => isBlank(billingInformation.address?.[field])));

// The billing endpoint replaces the whole record, so the form values are merged into what it holds
export const toBillingInformation = (
  billingInformation,
  { taxNumber, address1, address2, jurisdiction, city, postalCode, country },
) => ({
  ...billingInformation,
  taxNumber,
  address: {
    ...billingInformation?.address,
    address1,
    address2,
    jurisdiction,
    city,
    postalCode,
    country,
  },
});
